import styled from 'styled-components';
import { Link } from 'gatsby';

export const MobileMenu = styled.ul`
  display: flex;
  background-color: #fff;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: scroll;
  margin: 0;
  padding: 0;
  list-style-type: none;
  position: fixed;
  top: 0;
  left: 0;

  @media (max-width: 1018px) {
    display: flex;
  }
`;

export const StyledLink = styled(Link)`
  font: 28px/40px ${({ theme }) => theme.fonts.textFont}, sans-serif;
  text-transform: uppercase;
  display: block;
  font-weight: 700;
  color: #000;
`;

export const Sublink = styled(Link)`
  font: 22px/36px ${({ theme }) => theme.fonts.textFont}, sans-serif;
  text-transform: uppercase;
  display: block;
  font-weight: 700;
  color: #000;
`;

export const CloseTrigger = styled.div`
  width: 40px;
  height: 40px;
  position: fixed;
  top: 15px;
  right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  ::before,
  ::after {
    content: '';
    width: 40px;
    height: 4px;
    border-radius: 5px;
    background-color: #000;
    position: absolute;
  }
  ::before {
    transform: rotate(45deg);
  }
  ::after {
    transform: rotate(-45deg);
  }
`;
